import { render } from "./ModalConfirmationEmail.vue?vue&type=template&id=23084fd8&scoped=true&ts=true"
import script from "./ModalConfirmationEmail.vue?vue&type=script&lang=ts"
export * from "./ModalConfirmationEmail.vue?vue&type=script&lang=ts"

import "./ModalConfirmationEmail.vue?vue&type=style&index=0&id=23084fd8&lang=stylus&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23084fd8"]])

export default __exports__